/**
 * クッキー状態確認
 */
function checkCookieEnabled() {
  let key = 'checkCookie';
  document.cookie = key + '=1'
  if (document.cookie.indexOf(key) > -1) {
    document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
    return true;
  } else {
    return false;
  }
}

// Cookieが利用不可能かどうかをチェック
if (checkCookieEnabled() === false) {
  let msg = 'お使いのブラウザでCookieが無効になっているため、このサイトを正しく表示することができません。'
  + 'Cookieを有効にして、再度お試しください。';
    document.body.insertAdjacentHTML('afterbegin', '<div class="s-common s-common__error"><div>' + msg + '</div></div>');
}

/**
 * シークレットブラウザチェック　スタンプラリーがないのでコメントアウト
 */
/*
let url = new URL(location);
//console.log(url.pathname);
if (url.pathname !== '/faq/') {
  detectIncognito().then((result) => {
//    console.log(result.browserName, result.isPrivate);

    if (result.isPrivate == true) {
      let mode = 'シークレットブラウズ';
      if (result.browserName == 'Chrome') {
        mode = 'シークレットモード';
      }
      let msg = 'ブラウザが' + mode + 'になっているため、スタンプが消えてしまいます。通常モードでアクセスしてください。'
      + 'くわしくは<a href="/faq/#disappered">よくある質問</a>をご確認ください。';
      document.body.insertAdjacentHTML('afterbegin', '<div class="s-common s-common__error"><div>' + msg + '</div></div>');
    }
  });
}
  */

/**
 * ポップアップ消去
 */
document.addEventListener('click', function(event) {
  if (event.target.id === 'fatal-error') {
    event.target.remove();
  }
});

/**
 * カメラクリック時
 */
/*
if (document.getElementById('confirm_camera')) {

  const confirm_camera = document.getElementById('confirm_camera');

  const expiration = confirm_camera.dataset.expiration;

  confirm_camera.addEventListener('click', function() {
    confirm_camera.style.display = 'none';
  });

  const targets = document.querySelectorAll('.c-home__camera a');
  targets.forEach(function(element) {

    element.addEventListener('click', function(event) {
      view_confirm_camera(event);
    });
  });

  document.querySelector('#menu-mobile-footer > li a .fa-camera').parentElement.parentElement.addEventListener('click', function(event) {
    view_confirm_camera(event);
  });

  // カメラ確認メッセージ表示
  function view_confirm_camera(event) {
    event.preventDefault();
    confirm_camera.style.display = 'block';
  }

  // 確認
  const confirmed = document.getElementById('confirmed');
  confirmed.addEventListener('click', function(event) {
    document.cookie = 'notice_confirmed' + '=1; expires=' + expiration + '; path=/;';
  });
}
*/

/**
 * 別カメラの場合、サイト内メニューを非表示に
 */
if (document.getElementById('other_camera')) {

  document.getElementById('menu-mobile-footer').remove();

  const other_camera = document.getElementById('other_camera');

  const expiration = other_camera.dataset.expiration;

  // 確認
  const confirmed = document.getElementById('confirmed');
  confirmed.addEventListener('click', function(event) {
    if (document.getElementById('never_confirm').checked) {
      document.cookie = 'camera_confirmed' + '=1; expires=' + expiration + '; path=/;';
    }
  });
}

/**
 * ページ読み込み後
 */
window.addEventListener('load', (event) => {

  let gpsEnabled = false;

  function fatalError(msg, after) {

    let fatal_parent = document.getElementById('fatal-error');

    if (fatal_parent == null) {
      fatal_parent = document.createElement('div');
      fatal_parent.id = 'fatal-error';
      fatal_parent.classList.add('c-popup');

      fatal_parent.innerHTML = '<div class="c-popup__message">'
                             + '<h2>エラー</h2>'
                             + '</div>';

      document.body.insertAdjacentElement('beforeend', fatal_parent);

      fatal_parent.addEventListener('click', function() {

        if (after == null) {
          fatal_parent.remove();
        } else {
          location.href = after;
          return;
        }
      });
    }

    const target = fatal_parent.querySelector('.c-popup__message');
    const element = document.createElement('div');
    element.innerHTML = msg;
    target.insertAdjacentElement('beforeend', element);
  }


  /**
   * 位置情報確認
   */
  function checkGeolocation(target) {

    if (target == null) {
      target = document.body;
    }

    const msg = '位置情報を取得できる設定になっていません。<br>'
        + '<a href="/faq/#location">よくある質問</a>を参考に位置情報を取得できるよう設定してください。';

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function(position) {
        gpsEnabled = true;
        return true;
      }, function(error) {
        fatalError(msg);
        //target.insertAdjacentHTML('afterbegin', msg);
      });
    } else {
      //target.insertAdjacentHTML('afterbegin', msg);
      fatalError(msg);
    }
  }

  /*
  if (checkGeolocation() === false) {
    let msg = '<p class="fatal_error">申し訳ありません。'
    + '位置情報が取得できないため、このサービスをご利用いただくことができません。'
    + '推奨のブラウザをご使用くださいますようお願いいたします。</p>'
    document.body.insertAdjacentHTML('afterbegin', msg);
    return;
  }
  */

  /**
   * 角度をラジアンに変更
   */
  function degreesToRadians(degrees) {
    return degrees * (Math.PI / 180);
  }

  /**
   * 位置の距離取得
   */
  function getDistance(latitude1, longitude1, latitude2, longitude2) {
    var earthRadiusKm = 6371000; // 地球の半径（メートル）

    var dLat = degreesToRadians(latitude2 - latitude1);
    var dLon = degreesToRadians(longitude2 - longitude1);

    var lat1 = degreesToRadians(latitude1);
    var lat2 = degreesToRadians(latitude2);

    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    var distance = earthRadiusKm * c;
    return distance.toFixed(2); // 小数点第2位までの距離を返す
  }

  // QRコード読み込み後の位置情報確認
  if (document.getElementById('rally_gps') !== null) {

    const target = document.getElementById('rally_gps');
//    checkGeolocation(target);

    var gps_form = document.getElementById('rally_gps');

//    if (gpsEnabled === true) {
      navigator.geolocation.getCurrentPosition(function(position) {

        var current_lat = position.coords.latitude;
        var current_lng = position.coords.longitude;

        var spot_lat = document.getElementById('latitude').value;
        var spot_lng = document.getElementById('longitude').value;
        var range = parseInt(document.getElementById('range').value);

        distance = getDistance(current_lat, current_lng, spot_lat, spot_lng);

        if (gps_form !== null) {
          if (distance > range) {
            let msg = 'エリア範囲外のためスタンプの獲得ができません。'
              + '<a href="/map/?lat=' + current_lat + '&lng=' + current_lng + '">'
              + 'マップ</a> で現在地をご確認ください。<br>'
              + '現在地が正しくない場合は、現在地ボタン'
              + ' <i class="fas fa-location-arrow"></i> を何度か押してみてください。<br>'
              + '現在地が正しいことを確認の上、もう一度コードを読み直してみてください。';
            msg += '<br><a href="/map/?lat=' + current_lat + '&lng=' + current_lng + '">マップを見る</a>'
            fatalError(msg);
          } else {
            document.getElementById('current_lat').value = current_lat;
            document.getElementById('current_lng').value = current_lng;
            gps_form.submit();
          }
        }
      }, function(error) {

        // エラー時
        let msg = '';
        switch (error.code) {
          case 1:
            msg = '位置情報を取得できる設定になっていません。<br>'
                + '<a href="/faq/#location">よくある質問</a>を参考に位置情報を取得できるよう設定してください。';
            break;
          case 2:
            msg = '現在位置が特定できません。機内モードがONになっていないか等をご確認の上、恐れ入りますが、もう一度お試しください。'
            break;
          case 3:
            msg = '位置情報が取得できませんでした。恐れ入りますが、時間をおいてもう一度お試しください。'
        }
        fatalError(msg);
      }, {
        maximumAge: 0,
        timeout: 10000,
        enableHighAccuracy: true,
      });
//    }
  }

  // スタンプ獲得
  if (document.getElementById('rally_stamped') !== null) {
    document.querySelector('.entry-title').remove();
  }

  // 位置情報確認
  if (document.getElementById('rally_gps_status')) {

    var gps_form = document.getElementById('rally_gps_status');

    checkGeolocation(gps_form);

//    if (gpsEnabled === true) {
      navigator.geolocation.getCurrentPosition(function(position) {
        var current_lat = position.coords.latitude;
        var current_long = position.coords.longitude;

        var spot_lat = document.getElementById('latitude').value;
        var spot_long = document.getElementById('longitude').value;
        var range = parseInt(document.getElementById('range').value);

        distance = getDistance(current_lat, current_long, spot_lat, spot_long);

        if (gps_form !== null) {
          var msg = '';
          if (distance > range) {
            msg = '範囲外です';
          } else {
            msg = '範囲内です';
          }
          gps_form.insertAdjacentHTML('afterBegin', '<p class="rally_info">' + msg + '</p>');
        }
      });
//    }
  }

  // QRコードリーダー
  if (document.getElementById('rally_reader') !== null) {

    const rally_reader = document.getElementById('rally_reader');

    if (!document.querySelector('body.no-geo-location')) {
      checkGeolocation(rally_reader);
    }

    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {

      var video = document.createElement('video');
      var canvasElement = document.getElementById('rally_code');
      var canvas = canvasElement.getContext('2d');
      var loadingMessage = document.getElementById('loadingMessage');
      var loadingImage = document.getElementById('loadingImage');
      var siteurl = rally_reader.dataset.siteurl;

      function drawLine(begin, end, color) {
        canvas.beginPath();
        canvas.moveTo(begin.x, begin.y);
        canvas.lineTo(end.x, end.y);
        canvas.lineWidth = 4;
        canvas.strokeStyle = color;
        canvas.stroke();
      }

      // Use facingMode: environment to attemt to get the front camera on phones
      navigator
      .mediaDevices
      .getUserMedia({ video: { facingMode: "environment" } })
      .then(function(stream) {
        loadingImage.style.display = 'none';
        video.srcObject = stream;
        video.setAttribute("playsinline", true); // required to tell iOS safari we don't want fullscreen
        video.play();
        requestAnimationFrame(tick);
      })
      .catch(e => {
        let msg = 'カメラに接続できません。<br>'
          + '<a href="/faq/#camera">よくある質問</a>を参考にカメラを許可してください。';
        fatalError(msg);
      });

      function tick() {
//        loadingMessage.innerText = "Loading..."
        if (video.readyState === video.HAVE_ENOUGH_DATA) {
          loadingMessage.hidden = true;
          canvasElement.hidden = false;

          canvasElement.height = video.videoHeight;
          canvasElement.width = video.videoWidth;
          canvas.drawImage(video, 0, 0, canvasElement.width, canvasElement.height);
          var imageData = canvas.getImageData(0, 0, canvasElement.width, canvasElement.height);
          var code = jsQR(imageData.data, imageData.width, imageData.height, {
            inversionAttempts: "dontInvert",
          });
          if (code) {
            if (code.data.length > 0) {
              drawLine(code.location.topLeftCorner, code.location.topRightCorner, "#FF3B58");
              drawLine(code.location.topRightCorner, code.location.bottomRightCorner, "#FF3B58");
              drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, "#FF3B58");
              drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, "#FF3B58");

              var url = new URL(code.data);

              if (url.toString().indexOf(siteurl) === -1) {
//                console.log(url.toString());
//                console.log(siteurl);
                fatalError('この二次元コードはスタンプ用ではありません。');
                return;
              }

              var target = url.pathname + url.search;

              setTimeout(function() {
                location.href = target + '&camera=rally';
              }, 1000);

              return;
            }
          }
        }
        requestAnimationFrame(tick);
      }

    } else {
      let msg = '申し訳ありません。'
      + 'お使いのブラウザでは二次元コードの読込みができません。'
      + '標準カメラアプリまたは、二次元コードを読み込めるアプリをご利用ください。';
//      document.body.insertAdjacentHTML('afterbegin', msg);
      fatalError(msg);
      return;
    }
  }

  /**
   * 店舗スタンプ状況絞り込み
   */
  if (document.querySelector('.rally_spot_condition') !== null) {
    const url = new URL(location);
    let conditions = document.querySelectorAll('.rally_spot_condition input[type="radio"]');
    if (conditions.length > 0) {
      Array.from(conditions).forEach((condition) => {
        condition.addEventListener('click', () => {
          url.pathname = url.pathname.split('/page')[0];
          url.searchParams.set('cond', condition.value);
          location.href = url.href;
        });
      });
    }
  }

  /**
   * 店舗カテゴリ絞り込み
   */
  if (document.querySelector('.rally_spot_category') !== null) {
    const url = new URL(location);

    // セレクトボックス
    let select = document.querySelector('.rally_spot_category select');
    if (select !== null) {
      select.addEventListener('change', () => {
        url.pathname = url.pathname.split('/page')[0];
        url.searchParams.set(select.classList[0], select.value);
        location.href = url.href;
      });
    }

    // ラジオボタン
    let category_radios = document.querySelectorAll('.rally_spot_category ul input[type="radio"]');
    let category_radio_parent = document.querySelector('.rally_spot_category ul');

    if (category_radios.length > 0) {
      Array.from(category_radios).forEach((category_radio) => {
        category_radio.addEventListener('click', () => {
          url.pathname = url.pathname.split('/page')[0];
          url.searchParams.set(category_radio_parent.className , category_radio.value);
          location.href = url.href;
        });
      });
    }
  }

  /**
   * 店舗検索
   */
  if (document.querySelector('.rally_spot_search') !== null) {
    let input = document.querySelector('.rally_spot_search input');
    if (input !== null) {

      input.addEventListener('change', () => {
        var search_val = document.querySelector('.rally_spot_search input').value;
        const url = new URL(location);
        url.pathname = url.pathname.split('/page')[0];
        url.searchParams.set('search', search_val);
        location.href = url.href;
      });
    }
  }

  /**
   * 店舗一覧
   */
  if (document.getElementById('rally_spot_list') !== null) {
    _set_load_more('.spot_list', '.spot');
  }

  /**
   * 店舗詳細
  if (document.getElementById('rally_spot_detail') !== null)
  {
    // 校正中
    let button = document.querySelector('.mobile-menu-buttons');
    if (button) {
      button.remove();
    }
    let common = document.querySelector('.s-common');
    if (common) {
      common.remove();
    }
    let head = document.querySelector('#header-container');
    if (head) {
      head.remove();
    }
  }
  */

  /**
   * 履歴
   */
  if (document.getElementById('rally_history') !== null) {
//    _set_load_more('.stamp_history', '.stamp');

    // セレクトボックス変更で再読み込み
    if (document.getElementById('history_title') !== null) {

      document.getElementById('history_title').addEventListener('change', function() {

        const url = new URL(location);
//        console.log(this.value);
        url.searchParams.set('stage', this.value);
        location.href = url;
      });
    }
  }

  /**
   * フォーム
   */
  if (document.querySelector('.mw_wp_form_input')) {

    let reward2 = document.getElementById('reward2');

    if (reward2) {

      let dt = reward2.parentElement.nextElementSibling.querySelector('span');

      // 第2希望
      function check_reward2() {

        if (reward2.value == '') {
          dt.innerHTML = '任意';
          dt.classList.remove('required');
        } else {
          dt.innerHTML = '必須';
          dt.classList.add('required');
        }
      }

      reward2.addEventListener('change', function(event){
        check_reward2();
      });

      check_reward2();
    }

    // 年齢性別が未設定の時、アンケートがあればアンケートを反映

    if (document.getElementById('age') && document.getElementsByName('survery_age')) {
      if (document.getElementById('age').value == '') {

        if (document.getElementsByName('survey_age')[0] !== undefined) {
          document.getElementById('age').value = document.getElementsByName('survey_age')[0].value;
        }

      }
    }
    if (document.getElementById('gender') && document.getElementsByName('survery_gender')) {
      if (document.getElementById('gender').value == '') {

        if (document.getElementsByName('survey_gender')[0] !== undefined) {
          document.getElementById('gender').value = document.getElementsByName('survey_gender')[0].value;
        }
      }
    }

    // エラーがあるか
    let errors = document.querySelectorAll('.error');

    let amount = errors.length;

    if (amount > 0) {



      // スタイル追加
      errors.forEach(function(element) {

        let target = element.parentNode.querySelector('input,select,textarea');
        if (target == null) {
          element.parentElement.previousElementSibling.classList.add('error-item');
          element.parentElement.previousElementSibling.classList.add('error-item__check');
        } else {
          target.classList.add('error-item');
        }
      });

      // アンカー作成
      errors[0].parentNode.previousElementSibling.id = 'errorTarget';

      let error_msg = document.createElement('div');
      error_msg.id = 'errors';
      error_msg.innerHTML = '<strong>入力エラーが' + amount + '箇所あります</strong><small><a href="#errorTarget">▼エラーの場所へ▼</a></small>';

      let input = document.querySelector('.mw_wp_form_input');

      input.insertBefore(error_msg, input.querySelector('form'));
    }
  }

  // 確認画面
  if (document.querySelector('.mw_wp_form_confirm')) {

    let buttons = document.querySelectorAll('.mw_wp_form_confirm button');

    let flag = {};
    buttons.forEach(function(button, seq) {
      flag[button.name] = false;
      button.addEventListener('click', function(event) {
        if (flag[button.name]) {
          event.target.setAttribute('disabled', 'disabled');
        } else {
          flag[button.name] = true;
        }
      });
    });
  }

  function _set_load_more(container, item) {

    let target = document.querySelector(container);
    let last = target.dataset.last;

    if (last <= 1) {
      return;
    }

    let infScroll = new InfiniteScroll(target, {
      path: getPenPath,
      append: item,
      button: '.view-more-button',
      scrollThreshold: false,
      status: '.page-load-status',
    });

    function getPenPath() {
      const url = new URL(location);
      let next = this.loadCount + 2;
      if (last >= next) {
//        return './page/' + next + '/';
        url.pathname = url.pathname.split('/page')[0] + '/page/' + next + '/';
//        url.searchParams.set('paged', next);
        url.pathname = url.pathname.replace('//', '/');
        return url.href;
      }
    }
  }

  /**
   * 参加店一覧のスタンプ
   */
  if (document.querySelectorAll('.s-spots').length > 0) {

    // スタンプ画像URL 取得
    let stamped = document.querySelector('.spot_list').dataset.stamped;

    // スタンプ疑似要素のstyleタグ生成
    const styleElement = document.createElement('style');
    styleElement.textContent = '.c-spot-stamped:after{ background-image: url('+stamped+'); }';

    // styleタグをc-spotの後に付加
    let spot = document.querySelector('.c-spot');
    if (spot) {
      spot.appendChild(styleElement);
    }
  }

  /**
   * 応募フォームのクラス付加
   *
   * 郵便番号から自動で住所を入力するため、クラスを付加する。
   * zip…郵便番号
   * address1…北海道旭川市
   * address2…それ以降の住所
   */
  if (document.querySelectorAll('.s-entry-form').length > 0) {

    if (document.querySelectorAll('.zip').length > 0) {

      // form
      const formElement = document.querySelector('.mw_wp_form form');
      formElement.classList.add('h-adr');

      // span country
      const spanElement = document.createElement('span');
      spanElement.classList.add('p-country-name');
      spanElement.style.display = 'none';
      spanElement.textContent = 'Japan';
      formElement.appendChild(spanElement);

      // 郵便番号
      const zipElements = document.querySelectorAll('.zip');
      zipElements.forEach(element => {
        element.classList.add('p-postal-code');
      });

      // 住所1
      const address1Elements = document.querySelectorAll('.address1');
      address1Elements.forEach(element => {
        element.classList.add('p-region');
        element.classList.add('p-locality');
      });

      // 住所2
      const address2Elements = document.querySelectorAll('.address2');
      address2Elements.forEach(element => {
        element.classList.add('p-street-address');
        element.classList.add('p-extended-address');
      });

      new YubinBango.MicroformatDom();

    }
  }

  /**
   * エラーメッセージ
   */
  if (document.getElementById('fatal-error')) {

    let fatal_org = document.getElementById('fatal-error');

    document.body.appendChild(fatal_org);
  }

  /**
   * エラーメッセージクリック時
   */
  /*
  let common_error = document.querySelector('.s-common__error');
  if (common_error) {
    common_error.addEventListener('click', function() {
      common_error.remove();
    });
  };
  */
});

/**
 * マップ画面
 *
 */
if (document.querySelectorAll('.s-map').length > 0) {

  var map; // マップオブジェクト
  var marker = []; // オープンハウス情報のリスト

  //var pin = '/images/pin.png'; // ピン
  var pin_stamped_url = document.querySelector('.s-map__stamped_pin').value; // 取得済ピンURL
  var pin_not_stamped_url = document.querySelector('.s-map__not_stamped_pin').value; // 未取得ピンURL
  //var pin_bold = './images/pin_coupon.png'; // ピン(クーポン)
  //var pin_pickup = './images/pin_pickup.png'; // ピン(pickup)
  var myLocation = L.marker([0, 0]); // 現在地のマーカー
  //var pin_current_url = document.querySelector('.s-map__current_pin').value; // ピン
  var mylocation_pin = document.querySelector('.s-map__current_pin').value; // ピン

  // var icon_size_big = 30; // 選択時のピンのサイズ
  var init_zoom = document.querySelector('.s-map__init_zoom').value; // マップズームの初期値
  var cnt = 0; // 掲載数カウント
  //var center_lat = 43.773535; // 地図の中心緯度
  //var center_lng = 142.372703; // 地図の中心経度
  var center_lat =   document.querySelector('.s-map__init_lat').value; // 地図の中心緯度
  var center_lng =   document.querySelector('.s-map__init_lng').value; // 地図の中心経度


  var markerData = []; // jsonデータ
  var cateogry_list = []; // カテゴリ別リスト
  var filter = []; // 絞込リスト
  var stamp_collected_list; // 取得済スタンプ情報リスト
  stamp_collected_list = document.querySelector('.s-map__stamped').value;

  // Loading表示
  var h = $(window).height();
  //$('#loader-bg ,#loader').height(h).css('display', 'block');

  // 地図の作成
  var map = L.map('mymap').setView([center_lat, center_lng], init_zoom);
  window.map = map;
  map.zoomControl.setPosition('bottomright');

  var markerCluster = L.markerClusterGroup({
    //disableClusteringAtZoom: 18,
    maxClusterRadius: 35, // クラスターの範囲
    spiderfyDistanceMultiplier: 1.1, // ピン間隔
    iconCreateFunction: function (cluster) {
      return L.divIcon({
        className: 'cluster-icon',
        iconSize: ['26', '30'], // クラスタアイコンサイズ
        html:
          '<div class="cluster-icon-text">' +
          cluster.getChildCount() +
          '</div>',
      });
    },
  });

  var popup = L.popup().setLatLng([0, 0]).setContent('');

  // アイコン
  var pin_not_stamped_icon = L.icon({
    iconUrl: pin_not_stamped_url,
    iconSize: ['', '30'],
  });
  var pin_stamped_icon = L.icon({
    iconUrl: pin_stamped_url,
    iconSize: ['', '30'],
  });
  /*
  var pin_bold_icon = L.icon({
    iconUrl: pin_bold,
    iconSize: [26, 35],
  });
  var pin_pickup_icon = L.icon({
    iconUrl: pin_pickup,
    iconSize: [26, 35],
  });
  */

  // json open
  $.ajaxSetup({
    async: false,
  });

  $.ajax({
    dataType: 'json',
    url: '/wp-json/wp/custom/get_spot_data',
    error: function (jqXHR, textStatus, errorThrown) {
      console.log(errorThrown);
    },
    success: function (data) {
      // markerDataに設定
      markerData = data;

      // 絞り込み設定
      //filter = data['filter'];


      for (var i = 0; i < markerData.length; i++) {

        //markerData[i]['lon']
        markerData[i]['lon']  = markerData[i]['lng'];

        // 公開件数カウント
        cnt++;

        // 条件名一覧
        service_list = [];

        // 絞込条件毎のカウント
        /*
        for (var j = 0; j < filter.length; j++) {
          var filter_name = filter[j]['name'];

          if (filter_name == 'coupon') {
            filter_name = 'cou_id';
          }

          if(markerData[i][filter_name] != null ) {
            if (cateogry_list[filter[j]['text']]) {
              cateogry_list[filter[j]['text']] += 1;
            } else {
              cateogry_list[filter[j]['text']] = 1;
            }
            service_list.push(filter[j]['text']);
          }
        }
        */

        markerData[i]['service_list'] = service_list;

        markerData[i]['lat'] =
          Math.floor(markerData[i]['lat'] * 1000000) / 1000000;
        markerData[i]['lon'] =
          Math.floor(markerData[i]['lon'] * 1000000) / 1000000;

        // pin icon設定
        var setting_icon = pin_stamped_icon; // 表示pin
        if (stamp_collected_list.indexOf(markerData[i]['id']) === -1) {
          setting_icon = pin_not_stamped_icon;
        }
        marker[i] = L.marker(
          [markerData[i]['lat'], markerData[i]['lon']],
          { icon: setting_icon }
        );

        /*
        if(markerData[i]['cou_id'] != null ) {
          marker[i] = L.marker(
            [markerData[i]['lat'], markerData[i]['lon']],
            { icon: pin_bold_icon }
          );
        } else if(markerData[i]['pickup'] != null ) {
          marker[i] = L.marker(
            [markerData[i]['lat'], markerData[i]['lon']],
            { icon: pin_pickup_icon }
          );
        } else {
          marker[i] = L.marker(
            [markerData[i]['lat'], markerData[i]['lon']],
            { icon: pin_icon }
          );
        }
        */
        markerCluster.addLayer(marker[i]);

        markerEvent(i, markerData); // マーカーにクリックイベントを追加
      }

      // 絞込条件一覧 表示設定
      /*
      for (var j = 0; j < filter.length; j++) {
        $('#search_spot dl').append(
          '<dt><label><input type="checkbox" id="' +
            filter[j]['name'] +
            '" class="search_check"> ' +
            filter[j]['text'] +
            '（<span id="cnt">' +
            cateogry_list[filter[j]['text']] +
            '</span>）</label></dt>'
        );
      }
      */

    },
  });

  $.ajaxSetup({
    async: true,
  });

  /*
  if (cnt == 0) {
    $('#article').remove();
    $('main').append(
      '<div class="u-font14 u-mt5 u-text-center">現在ラーメン店の情報はありません。<br> また来てね♪</div>'
    );
  } else {
    if (cnt > 0) {
      //$('.total').append('店中' + cnt + '店を表示');
      //$('#cnt_visible').html(cnt); // 初期値として全件にする
      $('.total').prepend('全' + cnt + '店中/');
      $('.total').append('店表示');
      $('#cnt_visible').html(cnt); // 初期値として全件にする
    }

  }
  */
  //$('#article').show();


  // cookie チェックで初回表示処理
  /*
  var cookie_arr = document.cookie.split(';');
  var help_flg = true;
  var cookie_days = 7;
  var cookie_date = new Date();
  var cookie_date_str;
  cookie_arr.forEach(function(value) {
      if (value == 'linerweb=ramenmap') {
          help_flg = false;
      }
  });

  if (help_flg) {
    cookie_date.setTime(cookie_date.getTime() + cookie_days*24*60*60*1000);
    cookie_date_str = cookie_date.toGMTString();
    document.cookie = "linerweb=ramenmap;expires=" + cookie_date_str;
    $('#btn_help').click();
  }
  */


  /*
  * ------------------------------------------------------------
  * functions
  * ------------------------------------------------------------
  */

  // マップの大きさを画面のサイズに合わせる
  function mapResize() {

    var common_height = $('.s-common').outerHeight(); // スタンプ数表示高さ
    var header_height = $('#header').outerHeight(); // ヘッダの高さ
    var menu_height = $('#menu-mobile-footer').outerHeight(); // スマホメニュー高さ

    // 未ログイン時
    if (common_height === undefined) {
      common_height = 0;
    }

    // PC表示の時
    if ($('#menu-mobile-footer').css('display') == 'none') {
      menu_height = $('#menu-pc-header').outerHeight() + 2;
    }

    $('#mymap').innerHeight($(window).outerHeight()
    - common_height
    - header_height
    - menu_height
    );

    map.invalidateSize();
//    console.log('mapResize');
  }

  // マーカーが地図上に表示されているかチェックする
  function isShowMarker(num) {
    var latlngBounds = map.getBounds();
    var swLatlng = latlngBounds.getSouthWest();
    var swlat = swLatlng.lat();
    var swlng = swLatlng.lng();

    var neLatlng = latlngBounds.getNorthEast();
    var nelat = neLatlng.lat();
    var nelng = neLatlng.lng();

    if (
      markerData[num]['lat'] < swlat ||
      nelat < markerData[num]['lat'] ||
      markerData[num]['lng'] < swlng ||
      nelng < markerData[num]['lng']
    ) {
      return false;
    }
    return true;
  }

  /*
  * マップの状態を初期状態にする
  *
  * 以下の処理を行う
  * ・中心点を初期化
  * ・拡大率を初期化
  */
  function initMap() {
//    console.log('initMap');
    map.setView([center_lat, center_lng], init_zoom);
    //$('#spot_info').addClass('is_hidden');
    map.removeLayer(popup);
  }


  /**
   * スポット詳細　表示
   */
  function show_detail() {
//    console.log('show_detail');
    document.querySelector('.s-map__detail .c-loader').style.display = 'block';
    document.querySelector('.s-map__detail').style.opacity = '1';
    document.querySelector('.s-map__detail').style.transform = 'translateX(0)';
    document.querySelector('.s-map__detail button').style.display = 'block';
  }

  /**
   * スポット詳細　非表示
   */
  function hide_detail() {
//    console.log('hide_detail');
    document.querySelector('.s-map__detail .c-loader').style.display = 'none';
    document.querySelector('.s-map__detail').style.opacity = '0';
    document.querySelector('.s-map__detail').style.transform = 'translateX(-100%)';
    document.querySelector('.s-map__detail button').style.display = 'none';

    // iframeリセット
    var iframes = document.querySelectorAll('.s-map__detail iframe');
    iframes.forEach(
      iframe => iframe.remove()
    );

  }

  // マーカーにクリックイベントを追加
  function markerEvent(i) {

    marker[i].on('click', function () {

//      console.log('marker click');

      // 吹き出し表示
      /*
      popup.setLatLng([markerData[i]['lat'],markerData[i]['lon']]);
      popup.setContent('<a target="_blank" href="'
        + markerData[i]['spot_detal']  + '">'
        + markerData[i]['title'] + '</a>'
      );
      popup.openOn(map);
      */

      // 詳細情報をiframe表示
      // iframeリセット
      var iframes = document.querySelectorAll('.s-map__detail iframe');
      iframes.forEach(
        iframe => iframe.remove()
      );
      $('.s-map__detail').append('<iframe src="'+ markerData[i]['spot_detal'] + '?seq=' + markerData[i]['seq'] + '&map_detail"></iframe>');
      show_detail();

      // 選択ピンの位置調整
      /*
      lat_gap = map.getCenter().lat - map.getBounds().getSouth(); // 中心点と下境界点の差
      lng_gap = map.getCenter().lng - map.getBounds().getNorthEast().lng; // 中心点と左右の境界差

      var window_width = $(window).width();
      var detail_width = $('.s-map__detail').width();
      var detail_ratio = detail_width / window_width;
      var map_width = map.getBounds().getNorthEast().lng - map.getBounds().getSouthWest().lng;
      lng_gap = (1 - detail_ratio) / 2;
      lng_gap = (map_width / 2) - (map_width * lng_gap);
      map.setView([markerData[i]['lat'] ,markerData[i]['lng'] - lng_gap
      ]); // 地図表示領域の中心に表示
      */
      map.setView([markerData[i]['lat'] ,markerData[i]['lng']]);

    });
  }

  /*
  * マーカーの表示状態を更新する
  *
  * 絞り込み条件をみて、マーカーのチェック状態を更新する
  * 全て未チェックの場合は全件表示する
  * 条件はAND条件としている
  */
  function reloadMarker() {
//    console.log('reloadMarker');

    // 条件に応じて表示する
    var visible;
    var cnt_visible = 0;

    // 表示範囲内かチェック
    var bounds = map.getBounds();
    map_ne_lat = bounds.getNorthEast().lat;
    map_sw_lat = bounds.getSouthWest().lat;
    map_ne_lng = bounds.getNorthEast().lng;
    map_sw_lng = bounds.getSouthWest().lng;
    //console.log(map_ne_lat);

    // 絞り込み条件取得
    var stamp_uncollected = $('#search_stamp_uncollected').prop('checked');
    var stamp_collected = $('#search_stamp_collected').prop('checked');

    // マーカーループ
    for (let i = 0; i < markerData.length; i++) {
      visible = true;

      search_check_flg = false; // 絞り込み検索有無
      cat_flg = false; // 絞り込み条件一致

      // 絞り込み条件チェック
      if (!stamp_uncollected && stamp_collected) {

//        console.log('取得済のみ');

        // 取得済のみ
        if (stamp_collected_list.indexOf(markerData[i]['id']) === -1) {
          visible = false;
        }

      } else if(stamp_uncollected && !stamp_collected) {

        // 未取得のみ
        if (stamp_collected_list.indexOf(markerData[i]['id']) !== -1) {
          visible = false;
        }


      }



      // チェックされている絞り込み条件をチェック
      /*
      $.each($('.search_check'), function (key, value) {
        if ($(value).prop('checked') && !cat_flg) {
          search_check_flg = true;

          filter_name = $(value).attr('id');
          if (filter_name == 'coupon') {
            filter_name = 'cou_id';
          }
          if (markerData[i][filter_name]) {
            cat_flg = true;
          }
        }
      });

      // 絞り込み条件に該当しなかった場合
      if (search_check_flg && !cat_flg) {
        visible = false;
      }
      */

      if (visible) {
        cnt_visible++;

        // 表示領域のみ表示
        /*
        if (
          Number(markerData[i]['lat']) < map_ne_lat &&
          Number(markerData[i]['lat']) > map_sw_lat &&
          Number(markerData[i]['lon']) < map_ne_lng &&
          Number(markerData[i]['lon']) > map_sw_lng
        ) {
        } else {
          visible = false;
        }
        */
      } else {
      }

      // 表示処理
      if (visible) {
        markerCluster.addLayer(marker[i]);
      } else {
        markerCluster.removeLayer(marker[i]);
      }
    }
    $('#cnt_visible').html(cnt_visible);
  }

  /*
  * 初回表示時　チェック初期値設定
  *
  * URLパラメータからチェック状態を取得する
  * &で繋げてることで複数指定可能
  *
  * ex) クーポンあり&座敷で表示したい
  *     ⇒「…/ramenmap/?coupon&tatami」
  */
  /*
  function checkParam() {
    var url_param = location.search;
    var url_param_list;
    if (url_param.length > 0) {
      url_param = url_param.replace('?', '');
      url_param_list = url_param.split('&');
      for (let i = 0; i < url_param_list.length; i++) {
        $('#'+url_param_list[i]).prop('checked', true);
      }
    }
  }
  */


  /*
  * ------------------------------------------------------------
  * triggers
  * ------------------------------------------------------------
  */

  // 画面ロード時
  $(document).ready(function () {
    if (cnt > 0) {

      // 現在地セット
      var param = new URLSearchParams(window.location.search);
      if (param.get('lat') != null) {
        center_lat = param.get('lat');
        center_lng = param.get('lng');
        map.setView([center_lat, center_lng], 17);

        myLocation = L.marker([center_lat, center_lng], {
          icon: L.icon({
            iconUrl: mylocation_pin,
            iconSize: ['', '30'],
          }),
        }).addTo(map);
      };

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 19,
      }).addTo(map);

      map.addLayer(markerCluster);
      mapResize();
      reloadMarker();

      // ボタン、件数表示
      document.querySelector('#btn_filter').style.display = 'flex';
      document.querySelector('#btn_myLocation').style.display = 'flex';
      document.querySelector('#btn_help').style.display = 'flex';
      document.querySelector('.s-map__cnt').style.display = 'inline-block';
    }
  });

  // 画面表示完了時
  window.onload = function () {
    $('.s-map__loader').fadeOut(300);

    //$('#loader-bg').fadeOut(800);
    //$('#loader').fadeOut(300);
  };

  // 画面リサイズ時
  var timer = 0;
  $(window).resize(function () {
    if (timer > 0) {
      clearTimeout(timer);
    }

    timer = setTimeout(function () {
      mapResize();
    }, 200);
  });

  // 絞込 絞り込み条件クリック時
  $('.search_check').on('click', function () {
    //$('#spot_info').addClass('is_hidden');
    map.removeLayer(popup);
    reloadMarker();
  });

  // 絞込 絞り込みボタンクリック時
  $('.s-map__button--submit').click(function () {
    $.fancybox.close();
  });

  // 絞込 リセットボタンクリック時
  $('.s-map__button--reset').click(function () {
    $('.search_check').prop('checked', false);
    reloadMarker();
  });

  // 詳細の閉じるボタンクリック時
  document.querySelector('.s-map__detail button').addEventListener('click', function() {
    hide_detail();
  });

  // 現在地ボタンクリック時
  $('#btn_myLocation').click(function () {
    map.locate({ setView: true, maxZoom: 21, timeout: 20000 });
    return;
  });

  // mapの座標が変わった時
  /*
  map.addListener( "bounds_changed", function ( argument ) {
      console.log('bounds_changed');
      reloadMarker();
  });
  */

  // mapクリック時
  map.on('click', function (e) {
    //$('#spot_info').addClass('is_hidden');
    //$('#spot_info').hide();

    // 詳細非表示
    hide_detail();
  });

  // mapの更新が完了した時 初回のみ
  map.on('load', function (e) {
//    console.log('load');

    if ($('#cnt_visible').html() == '') {
//      console.log('tilesloaded');
      reloadMarker();
    }
  });

  // mapが変化
  /*
  map.on('moveend', function (e) {
    console.log('moveend');
    reloadMarker();
  });
  */

  map.on('zoomend', function (e) {
//    console.log('zoomend');
    reloadMarker();
  });
  map.on('dragstart', function (e) {
    //$('#spot_info').addClass('is_hidden');
    map.removeLayer(popup);
  });

  // クラスターピンクリック
  markerCluster.on('clusterclick', function (event) {
    map.setView(event.latlng); // マップの中央にピン表示
  });

  // 現在地取得成功時
  map.on('locationfound', function (e) {

    map.removeLayer(myLocation);

    myLocation = L.marker(e.latlng, {
      icon: L.icon({
        iconUrl: mylocation_pin,
        iconSize: ['', '30'],
      }),
    });
    myLocation.addTo(map);

    map.setView(e.latlng, 15);
  });

  // 現在地取得エラー時
  map.on('locationerror', function (e) {

    var popup = document.createElement("div");

    popup.className = "c-popup";
    popup.id = "fatal-error";

    var message = document.createElement("div");
    message.className = "c-popup__message";

    var h2 = document.createElement("h2");
    h2.textContent = "エラー";
    message.appendChild(h2);

    var div = document.createElement("div");
    div.textContent = "位置情報が取得できません。よくある質問を参考に位置情報の取得を許可してください。";

    var a = document.createElement("a");
    a.href = "/faq/#location";
    a.textContent = "よくある質問";
    div.appendChild(a);

    message.appendChild(div);
    popup.appendChild(message);

    // mainタグ内に追加
    var main = document.getElementById("main");
    main.append(popup, main.firstChild);

    //alert('現在地を取得できませんでした。' + e.message);
  });

}